import React, { useEffect, useState } from "react";
import HorizontalGridList from "components/HorizontalGridList";
import ModalGrid from "components/ModalGrid";
import api from "../api";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ExpandMoreOutlined } from "@mui/icons-material";
import CollapsibleDataTable from "components/CollapsibleDataTable";

const useStyles = makeStyles((theme) => ({
  insideMainAccordian: {
    width: "100%",
  },
}));

const RunEnrich = () => {
  const classes = useStyles();

  // Sources and Current Source index
  const [subLink, setSubLink] = useState(-1);
  const [sources, setSources] = useState([]);
  const [fieldDetails, setFieldDetails] = useState(null);

  // Add jobs for current source
  const [runningJobs, setRunningJobs] = useState([]);

  //All Tickers Available
  const [tickers, setTickers] = useState([]);
  const [enrichmentSources, setEnrichSources] = useState([]);
  const [transferSources, setTransferSources] = useState([]);

  //Refresh Button and OpenAccordians
  const [refresh, setRefresh] = useState(true);
  const [openRows, setOpenRows] = useState({});

  // On Did Mount
  useEffect(() => {
    api
      .getPullSources()
      .then((data) => {
        setSources(data);
        setSubLink(0);
      })
      .catch((err) => {
        console.log(err);
      });

    api
      .available_tickers("ABCD12345")
      .then((data) => {
        setTickers(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    // FETCH NEW META DATA FOR SOURCE
    setFieldDetails(null);
    setOpenRows({
      pull: {},
      enrichment: {},
      transfer: {},
    });

    if (subLink >= 0) {
      // GET META DATA FOR CURRENT DATA SOURCE
      api
        .meta(sources[subLink].key)
        .then((data) => {
          setFieldDetails(data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [sources, subLink]);

  // On Update sources subLink Refresh
  useEffect(() => {
    //Table clears first then updates for new source
    setRunningJobs([]);

    if (subLink >= 0) {
      // GET ALL RUNNING JOBS FOR CURRENT DATA SOURCE
      api
        .get_running_jobs("ABCD12345", sources[subLink].key)
        .then((data) => {
          setRunningJobs(data);
        })
        .catch((err) => {
          console.log(err);
        });

      // GET Enrichment sources and etc.
      setEnrichSources(sources[subLink]["enrichment_sources"]);
      setTransferSources(sources[subLink]["transfer_sources"]);
    }
  }, [sources, subLink, refresh]);

  return (
    <>
      {subLink >= 0 && fieldDetails ? (
        <>
          <HorizontalGridList
            subLink={subLink}
            setSubLink={setSubLink}
            sources={sources}
          />

          <h1>{sources[subLink].name}</h1>

          {fieldDetails["pull"] && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Pull Jobs </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <div className={classes.insideMainAccordian}>
                  <ModalGrid
                    source={sources[subLink]}
                    setRefresh={setRefresh}
                    formOptions={{
                      ticker: tickers,
                      enrichment_sources: enrichmentSources,
                      transfer_sources: transferSources,
                    }}
                    formFields={fieldDetails["pull"]["formFields"]}
                    combined
                    submitButton={api.create_pull_job}
                  />

                  <CollapsibleDataTable
                    source={sources[subLink]}
                    tableData={runningJobs.filter((value) => {
                      return value["type"] === "pulljob";
                    })}
                    setRefresh={setRefresh}
                    innerSet="pulljob_set"
                    outerTableFields={fieldDetails["pull"]["outerTableFields"]}
                    innerTableFields={fieldDetails["pull"]["tableFields"]}
                    deleteFunc={api.stop_job}
                    type="pull"
                    openRows={openRows}
                    setOpenRows={setOpenRows}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          )}

          {fieldDetails["enrich"] && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Enrich Jobs </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <div className={classes.insideMainAccordian}>
                  <ModalGrid
                    source={sources[subLink]}
                    setRefresh={setRefresh}
                    formOptions={{
                      ticker: tickers,
                      enrichment_sources: enrichmentSources,
                      transfer_sources: transferSources,
                    }}
                    formFields={fieldDetails["enrich"]["formFields"]}
                    combined
                    submitButton={api.create_enrichment_job}
                  />

                  <CollapsibleDataTable
                    source={sources[subLink]}
                    tableData={runningJobs.filter((value) => {
                      return value["type"] === "enrichmentjob";
                    })}
                    setRefresh={setRefresh}
                    innerSet="enrichmentjob_set"
                    outerTableFields={
                      fieldDetails["enrich"]["outerTableFields"]
                    }
                    innerTableFields={fieldDetails["enrich"]["tableFields"]}
                    deleteFunc={api.stop_job}
                    type="enrichment"
                    openRows={openRows}
                    setOpenRows={setOpenRows}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          )}

          {fieldDetails["transfer"] && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Transfer Jobs </Typography>
              </AccordionSummary>

              <AccordionDetails>
                <div className={classes.insideMainAccordian}>
                  <ModalGrid
                    source={sources[subLink]}
                    setRefresh={setRefresh}
                    formOptions={{
                      ticker: tickers,
                      enrichment_sources: enrichmentSources,
                      transfer_sources: transferSources,
                    }}
                    formFields={fieldDetails["transfer"]["formFields"]}
                    combined
                    submitButton={api.create_transfer_job}
                  />

                  <CollapsibleDataTable
                    source={sources[subLink]}
                    tableData={runningJobs.filter((value) => {
                      return value["type"] === "transferjob";
                    })}
                    setRefresh={setRefresh}
                    innerSet="transferjob_set"
                    outerTableFields={
                      fieldDetails["transfer"]["outerTableFields"]
                    }
                    innerTableFields={fieldDetails["transfer"]["tableFields"]}
                    deleteFunc={api.stop_job}
                    type="transfer"
                    openRows={openRows}
                    setOpenRows={setOpenRows}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          )}
        </>
      ) : (
        <h1>Loading</h1>
      )}
    </>
  );
};

export default RunEnrich;
